export default "__VITE_ASSET__403b662c__"